import React, { FC } from "react"
import { Subtitle, Title } from "@components/styles"
// eslint-disable-next-line import/no-unresolved
import { SwiperSlide } from "swiper/react"
import type { SwiperProps } from "swiper/react/swiper-react"
import { Autoplay } from "swiper"
import type { ImageSliderProps } from "./types"
import {
    InnerWrapper,
    ImageSliderWrapper,
    Social,
    SocialsWrapper,
    StyledSwiper
} from "./styles"

const slideProps: SwiperProps = {
    loop: true,
    speed: 6000,
    autoplay: {
        delay: 1,
        disableOnInteraction: false
    },
    mousewheel: false,
    keyboard: false,
    slidesPerView: "auto"
}

const tempImages = [
    <img
        src="/images/stories/image-slider-1.jpg"
        alt=""
        width={300}
        height={300}
    />,
    <img
        src="/images/stories/image-slider-2.jpg"
        alt=""
        width={300}
        height={300}
    />,
    <img
        src="/images/stories/image-slider-3.jpg"
        alt=""
        width={300}
        height={300}
    />,
    <img
        src="/images/stories/image-slider-4.jpg"
        alt=""
        width={300}
        height={300}
    />,
    <img
        src="/images/stories/image-slider-5.jpg"
        alt=""
        width={300}
        height={300}
    />,
    <img
        src="/images/stories/image-slider-6.jpg"
        alt=""
        width={300}
        height={300}
    />
]

const ImageSlider: FC<ImageSliderProps> = ({
    title,
    subtitle
}) => {
    return <ImageSliderWrapper>
        <InnerWrapper>
            <Subtitle>{subtitle}</Subtitle>
            <Title>{title}</Title>
            <SocialsWrapper>
                <Social
                    href="https://www.instagram.com/playunified_nl/"
                    target="_blank"
                    rel="noreferrer"
                >
                    <img
                        src="/icons/instagram.svg"
                        alt="instagram"
                        width={33}
                        height={33}
                    />
                </Social>
                <Social
                    href="https://www.facebook.com/SpecialOlympicsNL"
                    target="_blank"
                    rel="noreferrer"
                >
                    <img
                        src="/icons/facebook.svg"
                        alt="facebook"
                        width={33}
                        height={33}
                    />
                </Social>
                <Social
                    href="https://twitter.com/SO_NL/"
                    target="_blank"
                    rel="noreferrer"
                >
                    <img
                        src="/icons/twitter.svg"
                        alt="twitter"
                        width={33}
                        height={33}
                    />
                </Social>
            </SocialsWrapper>
        </InnerWrapper>
        <StyledSwiper
            modules={[Autoplay]}
            spaceBetween={12}
            {...slideProps}
        >
            {tempImages.map((image, index) => (
                // eslint-disable-next-line react/no-array-index-key
                <SwiperSlide key={index}>
                    {image}
                </SwiperSlide>
            ))}
        </StyledSwiper>
    </ImageSliderWrapper>
}

export default ImageSlider
